import { getDelQKeyUrl, parseQueryParams } from '@/utils/url';

export default {
    computed: {
        mixCanOperate() {
            const { token, inWx } = this.$store.state;
            if (inWx) {
                // 在微信里面需要授权用户信息
                return token;
            }
            return token;
        },
        mixPageUseQ() {
            const q = this.$route.query;
            const useQ = { ...q, ...parseQueryParams(location.href) };
            return useQ;
        },
    },
    methods: {
        // 将 methods 上的方法 绑定 this
        mixFunBingThis(funNameArr) {
            for (let i = 0; i < funNameArr.length; i++) {
                const funName = funNameArr[i];
                this[funName] = this[funName].bind(this);
            }
        },
        // 不可操作时的处理方法
        mixNoOperateHandel(url) {
            // const {} = this
            const { inWx } = this.$store.state;
            if (inWx) {
                const useUrl = getDelQKeyUrl(location.href);
                this.mixWxLoginUserInfo(url || useUrl);
            } else {
                this.mixH5LoginUserInfo(url);
            }
        },
        // 自己判断能否操作, 不可操作就 调用不可操作的 处理方法
        mixCanOperateHandel(url) {
            const { mixCanOperate } = this;
            if (!mixCanOperate) {
                this.mixNoOperateHandel(url);
                return false;
            }
            return true;
        },
    },
};
